/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Session_Not_EndedInputs */

const en_us2_workout_session_not_ended = /** @type {(inputs: Workout_Session_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workout is still in progress, so it has no summary yet.`)
};

const pt_br2_workout_session_not_ended = /** @type {(inputs: Workout_Session_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino ainda está em andamento, então ainda não tem resumo.`)
};

const es_419_workout_session_not_ended = /** @type {(inputs: Workout_Session_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este entrenamiento sigue en curso, así que todavía no tiene resumen.`)
};

const pt_pt2_workout_session_not_ended = /** @type {(inputs: Workout_Session_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino ainda está a decorrer, por isso ainda não tem resumo.`)
};

const fr_fr2_workout_session_not_ended = /** @type {(inputs: Workout_Session_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette séance est encore en cours, elle n'a donc pas encore de résumé.`)
};

const de_de2_workout_session_not_ended = /** @type {(inputs: Workout_Session_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Training läuft noch, daher gibt es noch keine Zusammenfassung.`)
};

const it_it2_workout_session_not_ended = /** @type {(inputs: Workout_Session_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo allenamento è ancora in corso, quindi non ha ancora un riepilogo.`)
};

/**
* | output |
* | --- |
* | "This workout is still in progress, so it has no summary yet." |
*
* @param {Workout_Session_Not_EndedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_session_not_ended = /** @type {((inputs?: Workout_Session_Not_EndedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Session_Not_EndedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_session_not_ended(inputs)
	if (locale === "es-419") return es_419_workout_session_not_ended(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_session_not_ended(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_session_not_ended(inputs)
	if (locale === "de-DE") return de_de2_workout_session_not_ended(inputs)
	if (locale === "it-IT") return it_it2_workout_session_not_ended(inputs)
	return en_us2_workout_session_not_ended(inputs)
});
export { workout_session_not_ended as "workout.session_not_ended" }